import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/GlobalStore';
import type { RetorikMainComponentConfiguration } from '@davi-ai/retorik-framework';
import EmptyVeille from './EmptyVeille';
import ScreenSaver from './ScreenSaver';
import SlideShow from './SlideShow';
import InfoChannel from './InfoChannel';
import CallToAction from './CallToAction';
import styles from './VeilleManager.module.css';

const componentsList: { [key: string]: React.FC<any> } = {
  ScreenSaver,
  InfoChannel,
  SlideShow,
};

const keysToExclude = ['activated', 'timer', 'muted'];

const ucFirst = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

interface VeilleManagerProps {
  timerRefresh: () => void;
  injectConfig?: RetorikMainComponentConfiguration;
}

const VeilleManager: React.FC<VeilleManagerProps> = ({ timerRefresh, injectConfig }) => {
  const veille = useSelector((state: RootState) => state.BotConfig.veille);
  const [allowedPages, setAllowedPages] = useState<string[]>([]);
  const [currentComponent, setCurrentComponent] = useState<string | undefined>();

  useEffect(() => {
    if (veille?.activated) {
      const temp: string[] = [];
      Object.keys(veille).forEach((key) => {
        if (!keysToExclude.includes(key)) {
          const activated = (veille as any)[key]?.activated || false;
          // InfoChannel requires injectConfig
          if (activated && (key !== 'infoChannel' || injectConfig)) {
            temp.push(ucFirst(key));
          }
        }
      });
      setAllowedPages(temp);
      setCurrentComponent(temp[0]);
    } else {
      setAllowedPages([]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [veille]);

  const switchComponent = () => {
    if (allowedPages.length > 1 && currentComponent) {
      const currentIndex = allowedPages.indexOf(currentComponent);
      currentIndex === allowedPages.length - 1
        ? setCurrentComponent(allowedPages[0])
        : setCurrentComponent(allowedPages[currentIndex + 1]);
    } else if (allowedPages.length === 1 && currentComponent) {
      setCurrentComponent(undefined);
      setCurrentComponent(currentComponent);
    }
  };

  return (
    <div onClick={timerRefresh} className={styles.container}>
      {allowedPages.length === 0 ? (
        <EmptyVeille />
      ) : currentComponent ? (
        allowedPages.map((name, index) => {
          const Comp = componentsList[name];
          return (
            currentComponent === name && (
              <Comp
                key={index}
                switchComponent={switchComponent}
                loop={allowedPages.length === 1}
                {...(name === 'InfoChannel' ? { injectConfig } : {})}
              />
            )
          );
        })
      ) : (
        <div style={{ display: 'none' }} />
      )}
      <CallToAction />
    </div>
  );
};

export default VeilleManager;
